import type { ConfluenceHomeBanner } from '@post-office/placement-create-pipeline/pipes';

import { createClientPipeline } from '@post-office/placement-create-pipeline/create-pipeline';

import { type MessageTemplateContext } from '../../..';

import { type JSX } from 'react/jsx-runtime';

export type HydrationResult = Record<string, never>;

type Pipe = ConfluenceHomeBanner<{
	messageContext: MessageTemplateContext;
	hydrationResult: HydrationResult;
}>;

const clientPipeline = createClientPipeline<Pipe>();

export const createRender: <
	U extends (renderProps: { onDismissed: () => void }) => JSX.Element | null,
>(
	render: U,
) => (renderProps: { onDismissed: () => void }) => JSX.Element | null = clientPipeline.createRender;
